/**
 * Endpoints públicos del admin de Leiten (cotizaciones).
 *
 * OJO: este host está fijo a producción y no sale de .env, igual que estaba en
 * ApiDolar.jsx. En desarrollo local este endpoint siempre pega a producción.
 * ApiBranchs.jsx sigue con su propio fetch al mismo host: pendiente unificarlo.
 * Anotado en PLAN-REFACTOR.md.
 */

import { ApiError } from './ApiLeiten';

const ADMIN_URL = 'https://admin.leiten.com.ar';

async function request(path) {
    const response = await fetch(`${ADMIN_URL}${path}`);

    if (!response.ok) {
        throw new ApiError(`GET ${path} respondió ${response.status}`, {
            status: response.status,
            url: `${ADMIN_URL}${path}`,
        });
    }

    return response.json();
}

export function getCurrencyNames() {
    return request('/api/getCurrencyNames');
}
